import { Component, Input, OnInit, inject } from '@angular/core';
import { NbDialogRef, NbCardModule, NbButtonModule, NbCheckboxModule, NbIconModule } from '@nebular/theme';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

/**
 * Aviso do módulo de inscrição. Com `mostrarConfirmacao`, vira a **tela de consentimento**
 * (LGPD): ocupa a janela inteira, inclusive no celular, e o envio só segue com a caixa marcada.
 *
 * Consentimento não é um alerta a mais: ele decide se dado pessoal de terceiro — inclusive de
 * criança — vai ser gravado. Diálogo pequeno no meio da tela some no meio do fluxo e é aceito
 * sem leitura.
 */
@Component({
  selector: 'app-dialog-alert',
  standalone: true,
  imports: [CommonModule, NbCardModule, NbButtonModule, NbCheckboxModule, NbIconModule, FormsModule],
  template: `
    <nb-card class="dialog-alert" [class.dialog-consentimento]="mostrarCheckbox">
      <nb-card-header>
        <nb-icon *ngIf="mostrarCheckbox" pack="eva" icon="shield-outline" class="icone-consentimento"></nb-icon>
        <span>{{ mostrarCheckbox ? 'Antes de enviar' : title }}</span>
      </nb-card-header>

      <nb-card-body>
        <p *ngIf="message">{{ message }}</p>

        <ng-container *ngIf="mostrarCheckbox">
          <p class="texto-consentimento">{{ msgConfirmacao }}</p>

          <nb-checkbox [(ngModel)]="valor_confirmacao" class="aceite">
            Li e concordo com o que está escrito acima.
          </nb-checkbox>
        </ng-container>
      </nb-card-body>

      <nb-card-footer class="footer-actions">
        <button *ngIf="mostrarCheckbox" nbButton status="basic" size="medium" (click)="voltar()">
          Voltar
        </button>
        <button
          nbButton
          status="primary"
          size="medium"
          [disabled]="mostrarCheckbox && !valor_confirmacao"
          (click)="confirmar()"
        >
          {{ mostrarCheckbox ? 'Concordo e enviar' : 'OK' }}
        </button>
      </nb-card-footer>
    </nb-card>
  `,
  styles: [
    `
      .dialog-consentimento {
        width: 100vw;
        max-width: 100vw;
        height: 100vh;
        height: 100dvh;
        max-height: 100dvh;
        margin: 0;
        border-radius: 0 !important;
        display: flex;
        flex-direction: column;
      }

      .dialog-consentimento nb-card-header {
        display: flex;
        align-items: center;
        gap: 0.6rem;
        font-size: 1.15rem;
      }

      .icone-consentimento {
        font-size: 1.5rem;
        color: var(--domus-gold, #c9a227);
      }

      .dialog-consentimento nb-card-body {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 1.5rem;
        padding: 1.5rem clamp(1rem, 6vw, 4rem);
      }

      .texto-consentimento {
        margin: 0;
        font-size: clamp(1rem, 2.6vw, 1.15rem);
        line-height: 1.6;
        color: var(--text-basic-color, #222b45);
      }

      .aceite {
        font-weight: 600;
      }

      .dialog-consentimento nb-card-footer {
        padding: 1rem clamp(1rem, 6vw, 4rem) calc(1rem + env(safe-area-inset-bottom, 0px));
      }
    `,
  ],
})
export class DialogAlertComponent implements OnInit {
  @Input() title!: string;
  @Input() message!: string;
  @Input() mostrarConfirmacao: boolean = false;
  @Input() msgConfirmacao: string = 'Confirmo';

  valor_confirmacao: boolean = false;

  mostrarCheckbox = false;

  ref = inject(NbDialogRef<DialogAlertComponent>);

  ngOnInit(): void {
    this.mostrarCheckbox = this.mostrarConfirmacao === true;
  }

  /** Sai sem consentir: quem chamou recebe `false` e não envia nada. */
  voltar() {
    this.ref.close(false);
  }

  confirmar() {
    this.ref.close(this.mostrarCheckbox ? this.valor_confirmacao : true);
  }
}
